import axios from "axios";
import { trackingConfig } from "@/config/trackingConfig";

export const API = `${trackingConfig.BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true, timeout: 15000 });

export const assetUrl = (url) => (url && url.startsWith("/api/") ? `${trackingConfig.BACKEND_URL}${url}` : url || "");

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.response?.status === 429 ? "Too many requests. Please try again shortly." : "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return String(detail?.msg || detail);
}

export const normalizeIndianPhone = (raw) => {
  let d = (raw || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return /^[6-9]\d{9}$/.test(d) ? d : null;
};

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
